export const removePTags = (htmlString: string) => {
	const regex = /<\/?p[^>]*>/g;
	return htmlString.replace(regex, '');
};

export function formatCalculatedLegal(legal: string) {
	return legal
		.replace(/^\*/, '')
		.replace(/<u>/g, '**')
		.replace(/<\/u>/g, '**')
		.replace(/<\/?[^>]+(>|$)/g, '');
}
